import { createSlice } from "@reduxjs/toolkit";
import { fetchEarningsMetricsReducer } from "../../reducer/earnings/fetchEarningsMetricsReducer";
const initialState = {
  data: {
    totalEarnings: 0,
    codCashOnDelivery: 0,
    onlinePayments: 0,
    adminFees: 0,
    commission: 0,
    netBalance: 0,
    withdrawals: 0,
    // Completed Pay-In settlements — drives the "Pay Out (Payment for Tiryaq)" card.
    completedPayIns: 0,
    transportationFees: 0,
    // Loyalty / promotion discount patients redeemed — a term of Total Earnings, so it needs
    // a default here or the "Loyalty Point & Marketing Promotion" card reads undefined.
    loyaltyPromotion: 0,
  },
  isLoading: false,
  error: null,
  // requestId of the most recent fetch. Only that request may write the result, so a slow
  // earlier response (e.g. "From only" while the user is still picking "To", or the
  // Dashboard's all-time fetch) can never overwrite the figures for the current filter.
  latestRequestId: null,
};
const earningsMetricsSlice = createSlice({
  name: "earningsMetrics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEarningsMetricsReducer.pending, (state, action) => {
        state.latestRequestId = action.meta.requestId;
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEarningsMetricsReducer.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.data = action.payload || initialState.data;
      })
      .addCase(fetchEarningsMetricsReducer.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.isLoading = false;
        state.error = action.payload || "Failed to load earnings metrics.";
        // Don't leave the previous filter's figures on screen as if they matched this one.
        state.data = initialState.data;
      });
  },
});
export default earningsMetricsSlice.reducer;
